const initialState = {
  // medias: [],
  media: null,
  isOpen: false,
  keepValues: false,
  title: "",
  titleEN: "",
  titleNL: "",
  titleFR: "",
  descriptionFR: "",
  descriptionEN: "",
  descriptionNL: "",
  altFR: "",
  altEN: "",
  altNL: "",
  copyrightFR: "",
  copyrightEN: "",
  copyrightNL: "",
  tags: [],
  creator: null,
  taggedUsers: [],
  isPrivate: false,
  inTheNews: false,
  mediaStatus: "DRAFT",
  csScope: "INTRA_SHARE",
  languages: ["FR", "NL", "EN"].sort()
};

export const mediaEditorReducer = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_MEDIA_EDITOR": {
      return initialState;
    }
    case "SET_MEDIA_EDITOR": {
      return { ...state, ...action.mediaEditor };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/media-editor.js